import React, {useEffect, useState} from "react"
import {Modal, Tree} from "antd"
import CustomButton from "../../components/CustomButton"
import {useTranslation} from "react-i18next"
import api from "./store/api"
import LocalLoading from "../../components/Loading/Local"
import {getParents, recalculate, treeFromList, updatePtmResourcesPrice} from "./helpers"

const PtmTree = (props) => {
    const {visible, setVisible, formState, object, project, setProject} = props
    const [checkedPtms, setCheckedPtms] = useState([]);
    const [state, setState] = useState(null)
    const [loading, setLoading] = useState(false)
    const {t} = useTranslation(['common', 'valid', 'action'])

    useEffect(() => {
        if (object) {
            getPtmById(object.id)
        }
    }, [object])

    let treeData = state ? treeFromList(state, 1) : []

    const onChange = (page, pageSize) => {
        getPtmById(page, pageSize)
    };

    function getPtmById() {
        setLoading(true)
        api.getAllPtmByObjectId({Id: object.id})
            .then(r => {
                let res = r.map((el, idx) => ({key: `${object.id}_${el.code}_${el.id}`, ...el}))
                setState(res)
            })
            .finally(() => setLoading(false))
    };

    const getPtmResourcesPrice = (checked, i) => {
        let objectIds = [object.id]
        updatePtmResourcesPrice(objectIds, checked, formState, setCheckedNew)
    }

    function setCheckedNew(checked) {
        let ptms = [...project.ptms, ...checked]
        ptms = ptms.sort((a, b) => {
            return a.code.localeCompare(b.code, undefined, {
                numeric: true,
                sensitivity: 'base'
            });
        })
        let objects = [...project.objects]
        let isObjectExist = objects.some(n => n.id === object.id)
        if (!isObjectExist) {
            objects.push(object)
        }
        recalculate(ptms, objects)
        setProject({ptms: ptms, objects: objects})
    }

    function save() {
        setVisible(false)
        let checkedNew = []
        let ids1 = project.ptms.filter(n => n.level === 1).map(n => n.id)
        checkedPtms.filter(f => f.level === 1).forEach(n => {//птм 1-го уровня общие для всех объектов
            let isExist = ids1.includes(n.id)
            if (!isExist) {
                checkedNew.push(n)
            }
        })
        let keys = project.ptms.filter(f => f.level !== 1).map(n => n.key)
        checkedPtms.filter(f => f.level !== 1).forEach(n => {
            let isExist = keys.includes(n.key)
            if (!isExist) {
                checkedNew.push(n)
            }
        })
        if (formState.isResource) {
            getPtmResourcesPrice(checkedNew)
        } else {
            setCheckedNew(checkedNew)
        }
    }

    const onSelect = (selectedKeys, info) => {
        let record = state.find(r => r.key === selectedKeys[0])
        if (record?.id !== 0) {
            //setPtmInfo({visible: true, record: record})
        }
    }

    const onCheck = (checkedKeys, info) => {
        //let checked = [...state.filter(r => checkedKeys.includes(r.key))]
        //let childrenMany = checked.map(s => s.children).reduce(function(a, b){ return a.concat(b) }, []);
        //checked = checked.filter(n => !childrenMany.includes(n))

        let checkedWithParents = getParents(state, checkedKeys)
        let list = checkedWithParents.map(n => {
            if(n.level !== 1) {
                n = {...n, obj: object.id}
            }
            return n
        })
        setCheckedPtms(list)
    }

    function handleCancel() {
        setVisible(false)
        setState(null)
    }

    return (
        <Modal
            destroyOnHidden
            footer={[
                <CustomButton
                    key="save"
                    //loading={isSending}
                    type="green"
                    onClick={save}
                >
                    {t('action:fixSelection')}
                </CustomButton>
            ]}
            title={`${t('action:choose')} ПТМы от ${object?.name}`}
            open={visible}
            width={900}
            onCancel={handleCancel}
        >
            {loading
                ? <LocalLoading/>
                : <Tree
                    checkable
                    className='custom-select'
                    treeData={treeData}
                    //onSelect={onSelect}
                    onCheck={onCheck}
                    selectable={false}
                />
            }
        </Modal>
    )
}
export default PtmTree

/*
let treeData2 = state?.filter(n => n.level === 1).map(item => {
    return {
        key: item.key,
        title: `${item.name} (${item.sum})`,
        //disableCheckbox: item.id === 0,
        children: state?.filter(n => n.parentId !== null && n.parentId === item.rePtmId)
            .map((el) => ({
                key: el.key,
                title: `${el.name} (${el.sum})`,
                //disableCheckbox: el.id === 0,
                children: state?.filter(n => n.parentId !== null && n.parentId === el.rePtmId)
                    .map(m => ({
                        key: m.key,
                        title: `${m.name} (${m.sum})`,
                        checkable: false,
                        children: state?.filter(n => n.parentId !== null && n.parentId === m.rePtmId)
                            .map(f => ({
                                key: f.key,
                                title: `${f.name} (${f.sum})`,
                                checkable: false
                            }))
                    }))
            }))
    }
})*/
